import React from "react";

import * as styles from "../styles/PageIndicator.module.css";

export interface PageIndicatorProps {
  currentPage: number;
  count: number;
  style?: React.CSSProperties;
  onClick?: (i: number) => void;
}

const PageIndicator = (props: PageIndicatorProps) => {
  return (
    <div
      className="unselectable"
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "row",
        paddingTop: 10,
        paddingBottom: 10,
        margin: 10,
        ...props.style,
      }}
    >
      {[...Array(props.count).keys()].map((i) => (
        <div
          key={i}
          onClick={() => {
            if (props.onClick) {
              props.onClick(i);
            }
          }}
          className={
            i === props.currentPage
              ? styles.pageIndicatorActive
              : styles.pageIndicator
          }
        />
      ))}
    </div>
  );
};

export default PageIndicator;
